<div class="modal-overlay">
  <div class="emp-leave-card">
    <div class="card-header">
      <h3>Employee Leave Entry</h3>
      <span class="subtitle">Enter your leave details and submit</span>
    </div>

    <div class="form-row">
      <label for="employeeCode">Employee Code</label>
      <input id="employeeCode" type="text" [(ngModel)]="add.employeeCode" placeholder="Enter employee code" />
    </div>

    <div class="form-row-slide">
    <div class="form-group-slide">
        <label for="cl">CL</label>
        <input 
            id="cl" 
            type="text" readonly
            [(ngModel)]="add.CL_REMAINING" />
    </div>

    <div class="form-group-slide">
        <label for="el">EL</label>
        <input 
            id="el" 
            type="text" readonly
            [(ngModel)]="add.EL_REMAINING" />
    </div>
</div>
<div class="form-row">
      <label for="leaveType">Leave Type</label>
      <select id="leaveType" [(ngModel)]="add.selectedLeaveType">
        <option [ngValue]="null" disabled selected>Select leave type</option>
        <option *ngFor="let type of leaveTypes" [value]="type.value">{{ type.label }}</option>
        <small>CL: {{ add.CL_REMAINING }}, EL: {{ add.EL_REMAINING }}</small>
      </select>
    </div>
<div class="form-group">
    
        <label for="half">Half Day</label>
        <input 
            id="half"
            type="checkbox"
            [(ngModel)]="add.IsHalfDay"
            (change)="add.IsHalfDay = $event.target.checked ? 0.5 : 1"  />
    
    </div>
    <div class="form-row" *ngIf="add.selectedLeaveType != 'OD'">
      <label for="leaveDate">Leave Date</label>
        <input id="leaveDate" type="date"  [(ngModel)]="add.leaveDate" />
      <!-- <p-calendar id="leaveDate" [(ngModel)]="add.leaveDate" dateFormat="dd/mm/yy" showIcon="true"></p-calendar> -->
    </div>
    <div class="form-row" *ngIf="add.selectedLeaveType == 'OD'">
      <label for="Fromdate">From Date</label>
        <input id="Fromdate" type="date"  [(ngModel)]="add.Fromdate" [min]="minFromDate"  />
      <!-- <p-calendar id="leaveDate" [(ngModel)]="add.leaveDate" dateFormat="dd/mm/yy" showIcon="true"></p-calendar> -->
    </div><div class="form-row" *ngIf="add.selectedLeaveType == 'OD'">
      <label for="Todate">To Date</label>
        <input id="Todate" type="date"  [(ngModel)]="add.Todate" [min]="minFromDate"
  [max]="maxToDate"/>
      <!-- <p-calendar id="leaveDate" [(ngModel)]="add.leaveDate" dateFormat="dd/mm/yy" showIcon="true"></p-calendar> -->
    </div>
    

    <div class="button-row">
      <button type="button" (click)="saveEntry()" class="btn-save">Save</button>
      <button type="button" (click)="cancelEntry()" class="btn-cancel">Cancel</button>
    </div>
  </div>
</div>
